import constants from 'common/constants'

import {ONBOARDING_ALLOCATION_SERVER_CALL} from './ActionTypes/ApiActionTypes'

/**
 * One call to the server-side Teacher Allocation API (`/onboarding/allocation/*`, AI servers
 * only). Every endpoint shares this action type: the wrappers in
 * OnboardingWizard/utils/allocationServerApi.ts name the path, method and body.
 *
 * @param {{path: string, method?: 'GET'|'POST'|'PATCH', query?: Record<string, unknown>, body?: unknown}} request
 */
export const requestAllocationServer = (request, onSuccess, onFailure) => {
  const query = Object.entries(request.query ?? {})
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join('&')
  return {
    type: ONBOARDING_ALLOCATION_SERVER_CALL,
    payload: {
      apiUrl: `${constants.api_onboarding_allocation}${request.path}`,
      getString: query ? `?${query}` : '',
      useBaseURL: true,
      requestType: request.method ?? 'GET',
      header: 'application/json',
      reduxActionType: '',
      body: request.body ?? {},
      onSuccess,
      onFailure,
    },
  }
}

/**
 * POST onboarding/save-progress (handoff §7): written only after the row is saved. `wizard`
 * omitted just stamps `savedAt`; only `progress, mode, country, curriculum, setup,
 * classesDraft` would be merged.
 */
export const requestSaveOnboardingProgress = (wizard, onSuccess, onFailure) => ({
  type: ONBOARDING_ALLOCATION_SERVER_CALL,
  payload: {
    apiUrl: constants.api_onboarding_save_progress,
    getString: '',
    useBaseURL: true,
    requestType: 'POST',
    header: 'application/json',
    reduxActionType: '',
    body: wizard ? {wizard} : {},
    onSuccess,
    onFailure,
  },
})
